<div class="week-picker" [class.is-disabled]="disabled()">
  <div
    class="input"
    [class.is-active]="!!popup"
    [class.is-danger]="isInvalid()"
    (click)="toggle($event)"
    (keydown.ArrowUp)="toggle($event)"
    (keydown.ArrowDown)="toggle($event)"
    (keyup.enter)="toggle($event)"
    tabindex="0"
  >
    Week&nbsp;{{ week ? week : "--" }}
    @if (showYears()) {
      <span>,&nbsp;{{ year ? year : "--" }}</span>
    }
  </div>
</div>
